import React from 'react';

import classNames from 'classnames';

import classes from './CardDetails.module.scss';
import { EntityPaymentMethodDetails } from '../../../shared/interfaces/entityPaymentMethodDetails';
import { formatCardExpirationDate } from '../../utils/formatCardExpirationDate/formatCardExpirationDate';
import { getHumanizeCardBrand } from '../../utils/getHumanizeCardBrand/getHumanizeCardBrand';

type CardDetailsProps = {
  paymentMethodDetails?: EntityPaymentMethodDetails | null;
};

const CardDetails = ({ paymentMethodDetails }: CardDetailsProps) => {
  if (!paymentMethodDetails) {
    return <p className={classes.noCardText}>Not Set</p>;
  }

  const expirationDate = formatCardExpirationDate(
    paymentMethodDetails.cardDetails.expMonth,
    paymentMethodDetails.cardDetails.expYear,
  );

  const humanizedCardBrand = getHumanizeCardBrand(paymentMethodDetails.cardDetails.brand);

  return (
    <div className={classNames(classes.container, 'private-info')}>
      <p>
        {humanizedCardBrand} ending in {paymentMethodDetails?.cardDetails.last4}
      </p>
      <p className={classes.smallText}>Exp. date {expirationDate}</p>
    </div>
  );
};

export { CardDetails };
